export default "__VITE_ASSET__BqzvbcKd__"